import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import "./List.vue?vue&type=style&index=0&id=0edd9e3c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0edd9e3c"]])

export default __exports__